import CsStrapi from "../../shared/csStrapi/csStrapi";
import CsCacheResources from "./CsCacheResources";
import CsConstant from "../../CsConstant";

export default class UserGuideResources extends CsCacheResources {

  constructor(lang, debugHandler, getCache, setCache, removeCache, forceRefresh = false) {
    super(debugHandler, getCache, setCache, removeCache, forceRefresh);
    this.lang = lang;
  }

  requestExternalResources = () => {
    return CsStrapi.getNormal(CsConstant.STRAPI_RESOURCES_DOCS, { lang: this.lang })
      .then(result => {
        this.debugHandler('---Documentation: Fetched external resources.', result);
        if (Array.isArray(result)) {
          this.setCache(this._cacheKey(), result);
          return Promise.resolve(result);
        } else {
          return Promise.reject('Documentation: Resource is malformed!');
        }
      });
  }

  _cacheKey = () => {
    return 'cs_user_guide_cache.' + this.lang;
  }
}
